import * as React from "react";
const SvgFiRrUpRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M6.41 23c-1.07 0-2.07-.42-2.83-1.17l-1.41-1.41A3.96 3.96 0 0 1 1 17.59c0-1.07.42-2.07 1.17-2.83l7.17-7.17-1.47-1.47C7 5.24 6.75 3.99 7.23 2.85A2.96 2.96 0 0 1 10 1h9.01c2.2 0 4 1.8 4 4v9c0 1.23-.7 2.29-1.84 2.77-1.14.47-2.39.23-3.27-.64l-1.48-1.48-7.17 7.17c-.76.76-1.76 1.17-2.83 1.17zM10 3c-.62 0-.86.47-.92.62-.06.14-.22.65.21 1.09l2.18 2.18c.19.19.29.44.29.71s-.11.52-.29.71l-7.88 7.88a1.983 1.983 0 0 0 0 2.82L5 20.42c.76.76 2.07.76 2.83 0l7.88-7.88a.996.996 0 0 1 1.41 0l2.18 2.18c.44.43.94.27 1.09.21.14-.06.62-.3.61-.92V5c0-1.1-.9-2-2-2z"
    />
  </svg>
);
export default SvgFiRrUpRight;
